export const list = [
    { 'filename': 'template', 'date': '20200218', 'title': 'sample' }
];


// WEBPACK FOOTER //
// ./src/static/reading/list.js